var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.664062,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#516CD3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 11C29.0502 11 31.9282 13.8491 31.9282 17.3636V22.4545C31.9282 25.9691 29.0502 28.8182 25.5001 28.8182C21.9499 28.8182 19.0719 25.9691 19.0719 22.4545V17.3636C19.0719 13.8491 21.9499 11 25.5001 11ZM14 23.7273H16.5918C17.2156 28.0447 20.9663 31.3636 25.5001 31.3636C30.0337 31.3636 33.7844 28.0447 34.4083 23.7273H37C36.4072 29.0366 32.1488 33.2522 26.7857 33.8392V39H24.2144V33.8392C18.8512 33.2522 14.5929 29.0366 14 23.7273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicFill);
export default __webpack_public_path__ + "static/media/mic-fill.f6c837ecf54ac9ded6107eab65df6d53.svg";
export { ForwardRef as ReactComponent };